import React from 'react';
import StyledComponent from '~/components/Styled/Styled';
import times from 'lodash/times';
import css from './TranslationRateBar.scss';
import logEvent from '~/util/analytics';
import { FormattedMessage } from 'react-intl';

interface State {
  rating: number;
  enabled: boolean;
  doneRating: boolean;
  visible: boolean;
}

class TranslationRateBar extends React.Component<Props, State> {
  static displayName = 'TranslationRateBar';

  constructor(props) {
    super(props);

    this.state = {
      rating: 0,
      doneRating: false,
      visible: true,
      enabled: true,
    };

    this.close = this.close.bind(this);
    this.ratingClicked = this.ratingClicked.bind(this);
  }

  close() {
    this.setState({ visible: false });
  }

  ratingClicked(rating) {
    if (this.state.rating) {
      return null;
    }

    logEvent('translation_rating', { rating });

    // This horrific block of code is for the animation sequence
    this.setState({ rating }, () => {
      setTimeout(() => {
        this.setState({ doneRating: true }, () => {
          setTimeout(() => {
            this.setState({ visible: false }, () => {
              setTimeout(() => {
                this.setState({ enabled: false });
              }, 400);
            });
          }, 2000);
        });
      }, 1000);
    });
  }

  render() {
    if (!this.state.enabled) {
      return null;
    }

    return (
      <div className={`${css.container} ${this.state.visible ? '' : css.transparent}`}>
        {!this.state.doneRating && (
          <span>
            <div className={css.label}>
              <FormattedMessage
                id="translation_rating.rate_translation"
                defaultMessage="Rate translation"
              />
            </div>
            {times(5, index => (
              <div
                onClick={() => {
                  this.ratingClicked(index + 1);
                }}
                className={this.state.rating < index + 1 ? css.starGrey : css.starBlue}
              />
            ))}
            <div className={css.closeButton} onClick={this.close}>
              ✕
            </div>
          </span>
        )}
        <div className={this.state.doneRating ? css.thanksLabel : css.transparent}>
          <FormattedMessage
            id="translation_rating.thank_you_message"
            defaultMessage="Thank you for rating!"
          />
        </div>
      </div>
    );
  }
}

export default StyledComponent(TranslationRateBar, [css]);
